export { RecentActivitySection, RECENT_ACTIVITY_SECTION_ID } from './recent-activity-section';
